const FinancingAndPaymentsRoutes = [
  {
    path: "/financing-and-payments",
    name: "FinancingAndPayments",
    component: () => import("@/components/financing/Financing.vue"),
  },
  {
    path: "/wallet-details/:walletId",
    name: "WalletDetails",
    component: () => import("@/components/financing/WalletDetails.vue"),
  },
  {
    path: "/master-wallet-details",
    name: "MasterWalletDetails",
    component: () => import("@/components/financing/MasterWalletDetails.vue"),
  },
];

export default FinancingAndPaymentsRoutes; 